// PlayerDefeatHandler.js
// 处理玩家失败（HP为0）的公共模块

import DebugHelper from './DebugHelper.js';
import GameStateStore from './GameStateStore.js';
import { isCave } from './SceneClassHelper.js';

export default class PlayerDefeatHandler {
    /**
     * 处理玩家被击败（HP为0）
     * 传送到城镇出生点
     * @param {Phaser.Scene} scene - 当前场景
     * @param {string} previousSceneKey - 之前的场景key（可选，用于停止之前的场景）
     */
    static handlePlayerDefeated(scene, previousSceneKey = null) {
        const playerData = scene.player || GameStateStore.getPlayer();
        if (!playerData) {
            DebugHelper.warn('PlayerDefeatHandler: 无法获取玩家数据');
            return;
        }
        
        // 检查是否是副本场景（战斗场景不需要检查）
        const sceneConfig = scene.worldMapJson?.sceneConfig;
        const cave = isCave(sceneConfig);
        const isBattleScene = scene.scene.key === 'BattleScene';
        
        // 如果是战斗场景，或者是在副本中，才需要传送
        if (!isBattleScene && !cave) {
            DebugHelper.log('PlayerDefeatHandler: 不在副本中，不需要传送');
            return;
        }
        
        DebugHelper.log('PlayerDefeatHandler: 玩家HP为0，传送到城镇出生点', {
            isBattleScene,
            isCave: cave,
            playerHp: playerData.hp
        });
        
        // 找到城镇出生点（优先使用拉多镇的出生点）
        // 注意：缓存key是'map_rado'，不是JSON中的key字段'拉多镇'
        const townMapKey = 'map_rado'; // 默认城镇的缓存key
        const townMapData = scene.cache.json.get(townMapKey);
        
        DebugHelper.log('PlayerDefeatHandler: 尝试获取城镇地图', { townMapKey, found: !!townMapData });
        
        if (townMapData && townMapData.defaultSpawn) {
            const spawn = townMapData.defaultSpawn;
            const targetScene = townMapData.sceneConfig?.sceneKey || 'map_rado';
            
            // 恢复玩家HP到1（避免立即再次死亡）
            playerData.hp = 1;
            GameStateStore.patchPlayer({ hp: 1 });
            
            // 更新HUD（如果场景有worldUI）
            if (scene.worldUI) {
                scene.worldUI.updateHUD(playerData);
            }
            
            // 创建传送配置
            const exit = {
                targetScene: targetScene,
                targetTileX: spawn.tileX,
                targetTileY: spawn.tileY
            };
            
            // 使用过渡动画传送
            if (scene.transition) {
                // 世界场景使用transition（会自动处理场景切换）
                scene.transition.transitionToScene(exit, { useFade: true, sound: 'into' });
            } else {
                // 战斗场景：需要先停止所有相关场景，然后启动新场景
                if (isBattleScene) {
                    // 停止战斗场景
                    scene.scene.stop('BattleScene');
                    
                    // 如果之前的场景存在（可能是副本），也停止它
                    if (previousSceneKey && scene.scene.get(previousSceneKey)) {
                        scene.scene.stop(previousSceneKey);
                    }
                    
                    // 启动新场景（城镇）
                    scene.scene.start(targetScene, {
                        spawnX: spawn.tileX,
                        spawnY: spawn.tileY,
                        inVehicle: false,
                        transitionIn: true
                    });
                } else {
                    // 世界场景直接切换（使用start会停止当前场景）
                    scene.scene.start(targetScene, {
                        spawnX: spawn.tileX,
                        spawnY: spawn.tileY,
                        inVehicle: false,
                        transitionIn: true
                    });
                }
            }
        } else {
            DebugHelper.error('PlayerDefeatHandler: 无法找到城镇出生点');
        }
    }
}

